export default {
  app: {
    featured: 'In primo piano',
    random: 'Casuale',
    explore: 'Esplora',
    keywords: 'Parole chiave',
    search: 'Cerca',
  },
  explore: {
    filters: 'Filtri',
    resetFilters: 'Cancella filtri',
    addKeyword: 'Aggiungi parola chiave',
  },
  recipe: {
    contributedBy: 'Contribuito da',
    ingredients: 'Ingredienti',
    directions: 'Istruzioni',
    fullRecipe: 'Vedi la ricetta completa su',
    similarDrinks: 'Drink simili',
  },
  featuredRecipes: {
    loadMore: 'Carica altro',
  },
  recipeFind: {
    filterBy: 'Filtra per',
    name: 'Nome',
    ingredients: 'Ingredienti',
    keywords: 'Parole chiave',
    searchForIngredients:
      'Puoi fare una ricerca utilizzando più ingredienti separandoli con uno spazio',
    searchForKeywords:
      'Puoi fare una ricerca utilizzando più parole chiave separandole con uno spazio',
  },
  recipeList: {
    viewRecipe: 'Visualizza ricetta',
  },
  recipeToolbar: {
    print: 'Stampa',
    share: 'Condividi',
    shareOnFacebook: 'Condividi su Facebook',
    shareOnTwitter: 'Condividi su Twitter',
    copyURL: 'Copia URL',
    hideImage: 'Nascondi immagine',
  },
  favorites: {
    removeAllFavorites: 'Rimuovi tutti i preferiti',
    noFavoriteDrinks: 'Non hai nessun drink preferito',
    removeFavoritesPrompt: 'Sei sicuro di voler rimuovere tutti i preferiti',
    delete: 'Elimina',
    cancel: 'Annulla',
  },
  keywordList: {
    enterYourKeyword: 'Inserisci la tua parola chiave',
  },
  search: {
    findYourDrink: 'Trova il tuo drink',
  },
  pageNotFound: {
    pageNotFound: 'La pagina che stai cercando non è disponibile.',
    backToHome: 'Torna in Home',
  },
};
